module.exports = __webpack_public_path__ + "static/media/navyTri.f63bae3d.svg";